import { useEffect } from "react";
import { Link, useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";

/** Safe generic error page used as the router's errorElement. Never renders raw error detail. */
export function ErrorPage() {
  const error = useRouteError();
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="empty-state">
      <h1>Something went wrong</h1>
      <p>We hit an unexpected error loading this page. Please try again.</p>
      <Link to="/" className="btn btn-primary">
        Back to marketplace
      </Link>
    </div>
  );
}
